import styled from "@emotion/styled";
import React from "react";
import { RequiredThemeKeys } from "../../../util/theme";
import { Spinner } from "../../spinner";
import { getButtonTextColor } from "../styled/getButtonTextColor";
import { ButtonAppearances } from "../types";

type LoadingSpinnerProps = {
    appearance: ButtonAppearances;
    themeMode: RequiredThemeKeys;
};

export const LoadingSpinner = ({ appearance, themeMode }: LoadingSpinnerProps) => (
    <StyledLoadingSpinner>
        <Spinner
            size="medium"
            color={getButtonTextColor({
                appearance,
                themeMode,
                state: {
                    isActive: false,
                    isDisabled: false,
                    isFocus: false,
                    isHover: false,
                },
            })}
        />
    </StyledLoadingSpinner>
);

const StyledLoadingSpinner = styled("div")`
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;
